import { render } from "./ProcessSuggestionForm.vue?vue&type=template&id=bd6b6586&ts=true"
import script from "./ProcessSuggestionForm.vue?vue&type=script&lang=ts"
export * from "./ProcessSuggestionForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__